import { useState } from "react";
import { BadgeDollarSign } from "lucide-react";
import { StarIcon } from "@heroicons/react/24/solid";
import getSymbolFromCurrency from 'currency-symbol-map';

export default function PlaceDetails({ place }) {
  console.log('[PlaceDetails] place prop:', place);

  const [expanded, setExpanded] = useState(false);

  const hasCaption = Boolean(place?.caption);
  const isLongCaption = hasCaption && String(place.caption).length > 160;
  const ratingValue = Number(place?.review);
  const isNumericRating = !Number.isNaN(ratingValue) && ratingValue >= 0 && ratingValue <= 5;
  const companionshipItems = Array.isArray(place?.companionship)
    ? place.companionship
    : place?.companionship
      ? [place.companionship]
      : [];

  return (
    <div className="p-4 pt-0 bg-black/60 text-white backdrop-blur-sm">
      {place.place_name && (
        <div className="flex items-center gap-2">
          <h3 className="text-lg font-semibold leading-tight">
            {place.place_name}
          </h3>
          {place.country && (
            <img
              src={`/assets/flags/${place.country.toLowerCase()}.svg`}
              alt={place.country}
              title={place.country}
              className="inline-block h-3 object-cover rounded-sm"
            />
          )}
        </div>
      )}

      {hasCaption && (
        <div className="mt-2">
          <p className={`text-sm text-white/90 ${!expanded ? 'line-clamp-3' : ''}`}>
            {place.caption}
          </p>
          {isLongCaption && (
            <button
              type="button"
              className="mt-1 text-xs text-white/70 hover:text-white underline-offset-2 hover:underline"
              onClick={() => setExpanded((v) => !v)}
            >
              {expanded ? 'Show less' : 'Show more'}
            </button>
          )}
        </div>
      )}

      <div className="mt-3 flex flex-wrap items-center gap-2">
        {place.price && place.currency && (
          <span className="inline-flex items-center gap-1 rounded-full bg-white/10 px-2 py-1 text-sm">
            {/* <BadgeDollarSign className="w-4 h-4 text-emerald-300" /> */}
            <span className="text-white/90">{getSymbolFromCurrency(place.currency)} {place.price}</span>
          </span>
        )}

        {place.review && (
          <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-2 py-1 text-sm">
            {isNumericRating ? (
              <span className="flex items-center gap-1">
                {[0,1,2,3,4].map((i) => (
                  <StarIcon
                    key={i}
                    className={`w-4 h-4 ${i < Math.round(ratingValue) ? 'text-yellow-300' : 'text-white/20'}`}
                  />
                ))}
                {/* <span className="ml-1 text-white/90">{ratingValue.toFixed(0)}</span> */}
              </span>
            ) : (
              <span className="flex items-center gap-1">
                <StarIcon className="w-4 h-4 text-yellow-300" />
                <span className="text-white/90">{place.review}</span>
              </span>
            )}
          </span>
        )}
      </div>

      {companionshipItems.length > 0 && (
        <div className="mt-2 text-sm">
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-white/60 font-semibold">Companionship:</span>
            {companionshipItems.map((item) => (
              <span
                key={String(item)}
                className="rounded-full bg-white/10 px-2 py-0.5 text-white/90"
              >
                {item}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
